import { render, staticRenderFns } from "./MyAchievement.vue?vue&type=template&id=2472ac48&scoped=true&"
import script from "./MyAchievement.vue?vue&type=script&lang=js&"
export * from "./MyAchievement.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/MainCertificate.css?vue&type=style&index=0&id=2472ac48&scoped=true&lang=css&"
import style1 from "./MyAchievement.vue?vue&type=style&index=1&id=2472ac48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472ac48",
  null
  
)

export default component.exports